import { message } from 'antd';
import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import { SEARCH_VISIT_REPORT, SEARCH_VISIT_REPORT_START, SEARCH_VISIT_REPORT_SUCCESS, SEARCH_VISIT_REPORT_ERROR, CLEAR_SEARCH_VISIT_REPORT, RESET_VISIT_REPORT, RESET_VISIT_REPORT_START, RESET_VISIT_REPORT_SUCCESS, RESET_VISIT_REPORT_ERROR } from "../actions/visitReportAction";
import { resetVisitReportAPI, searchVisitReportAPI, updateVisitRadiologistAPI } from "../../services/visits-report-service";
// import { UPDATE_VISIT_RADIOLOGIST, UPDATE_VISIT_RADIOLOGIST_START, UPDATE_VISIT_RADIOLOGIST_ERROR, UPDATE_VISIT_RADIOLOGIST_SUCCESS } from "../../actions/admin/visitReportsAction";

function* searchVisitReport({ payload }) {
    try {
        yield put({ type: CLEAR_SEARCH_VISIT_REPORT })
        yield put({ type: SEARCH_VISIT_REPORT_START })
        const response = yield call(searchVisitReportAPI, payload);
        if (response.success) {
            yield put({ type: SEARCH_VISIT_REPORT_SUCCESS, visitReport: response.data })
        } else {
            yield put({ type: SEARCH_VISIT_REPORT_ERROR, error: response.error })
            message.error(response.error);
        }
    } catch (error) {
        message.error('Failed to fetch visit reports!');
        yield put({ type: SEARCH_VISIT_REPORT_ERROR, 'error': error })
    }
}

// function* updateVisitRadiologist({ payload }) {
//     try {
//         yield put({ type: UPDATE_VISIT_RADIOLOGIST_START })
//         const response = yield call(updateVisitRadiologistAPI, payload);
//         if (response.success) {
//             yield put({ type: UPDATE_VISIT_RADIOLOGIST_SUCCESS, visitReport: response.data })
//         } else {
//             yield put({ type: UPDATE_VISIT_RADIOLOGIST_ERROR, error: response.error })
//             message.error(response.error);
//         }
//     } catch (error) {
//         message.error('Failed to update radiologist!');
//         yield put({ type: UPDATE_VISIT_RADIOLOGIST_ERROR, 'error': error })
//     }
// }

function* resetVisitReport({ payload }) {
    try {
        yield put({ type: RESET_VISIT_REPORT_START })
        const response = yield call(resetVisitReportAPI, payload);
        if (response.success) {
            const response2 = yield call(searchVisitReportAPI, payload);
            if (response2.success) {
                yield put({ type: SEARCH_VISIT_REPORT_SUCCESS, visitReport: response2.data })
            }
            yield put({ type: RESET_VISIT_REPORT_SUCCESS, visitReport: response.data })
            message.success('Visit sent to radiologist worklist successfully!')
        } else {
            yield put({ type: RESET_VISIT_REPORT_ERROR, error: response.error })
            message.error(response.error);
        }
    } catch (error) {
        message.error('Failed to reset study!');
        yield put({ type: RESET_VISIT_REPORT_ERROR, error  })
    }
}

function* getVisitReporstWatcher() {
    yield takeLatest(SEARCH_VISIT_REPORT, searchVisitReport);
    // yield takeLatest(UPDATE_VISIT_RADIOLOGIST, updateVisitRadiologist)
    yield takeLatest(RESET_VISIT_REPORT, resetVisitReport);
}

export default function* rootSaga() {
    yield all([getVisitReporstWatcher()])
}